export default __webpack_public_path__ + "static/media/calendar-pup.06d970e7.svg";